import { Component, OnInit, Input, SimpleChanges } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import * as words from '../../../../services/language'
import { MessageService } from '../../../../services/message.service';
import { MasterService } from '../../../../services/master.service';
import { StoreService } from '../../../../services/store.service';
import { ago } from 'src/app/utils/date';
import { Payment } from 'src/app/models/payment.model';
import moment from 'moment';

@Component({
    selector: 'downs-deposits',
    templateUrl: './downs-deposits.component.html',
    styleUrls: ['./downs-deposits.component.scss'],
    standalone: false
})
export class DownsDepositsComponent implements OnInit {

    // **************************
    // ****** variables *********
    // **************************

    // Unique internal identity of the lot whose down payments will be queried for.
    @Input() lotId: number = 0

    // Unique internal identity of the contact whose down payments will be queried for, overrides the lotId.
    @Input() contactId: number = 0

    // Unique internal identity of the sale finance type to filter the queried down payments with.
    @Input() financeTypeId: number = 0

    // Currently selected language
    @Input() language: string = 'EN'

    // Word replacements for each language.
    private words: Object = words.language

    //
    protected payments: Array<Payment> = []

    //
    private records: number = 0

    //
    private page: number = 1

    // Indicates whether the data is currently loading.
    protected loading: boolean = false

    // Indicates whether any more data is available
    protected exhausted: boolean = false

    constructor (private route: ActivatedRoute, private router: Router, private ms: MessageService, private master: MasterService, private store: StoreService) {}

    ngOnInit() {
        this.fetch()
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (!changes) {
            return
        }

        const first = Object.values(changes).some(c => c.isFirstChange())
        if (first) {
            return
        }

        if (changes.lotId || changes.contactId || changes.financeTypeId) {
            this.reset()
            this.fetch()
        }
    }

    private reset = (): void => {
        this.page = 1
        this.exhausted = false
        this.records = 0
    }

    private fetch = (): void => {
        if (this.loading) {
            return
        }

        if (this.exhausted) { // currently showing all available records?
            return
        }

        let lotParam = ''
        if (this.lotId && (this.lotId > 0)) {
            lotParam = `&lot=${this.lotId}`
        }

        let contactParam = ''
        if (this.contactId && (this.contactId > 0)) {
            contactParam = `&contact=${this.contactId}`
            lotParam = ''
        }

        let financeTypeParam = ''
        if (this.financeTypeId && (this.financeTypeId > 0)) {
            financeTypeParam = `&financeType=${this.financeTypeId}`
        }

        this.loading = true
        if (this.page === 1) {
            this.payments = []
        }

        this.master.get(`payments/scheduled?page=${this.page}&sort=due|ASC${lotParam}${contactParam}${financeTypeParam}&categories=deposit,initial%20down,deferred%20down&statuses=partially%20paid,unpaid`, (res) => {
            this.loading = false
  
            if (!res || !res.data) {
                this.ms.sendMessage("alert", { type: "danger", text: this.words[this.language]['apiNoResponse'] });
                return
            }
  
            if (res.status !== 200) {
                this.ms.sendMessage("alert", { type: "danger", text: res.data.error });
                return
            }
  
            this.records = res.data.records
            this.exhausted = (res.data.next === null)
  
            if (this.page > 1) {
                this.payments = this.payments.concat(res.data.payments)
                return
            }
  
            this.payments = res.data.payments
        })
    }

    protected dueToClass = (due: Date): string => {
        return ago(moment(due).format('YYYY-MM-DD'))
    }

    /**
     * A payment in the list was clicked. 
     * @param payment The payment object that was chosen by the user.
     */
    protected selected = (e: Event, payment: Payment): void => {
        e.preventDefault()
        e.stopPropagation()
        
        if (!payment || !payment.contactId) {
            return
        }

        this.router.navigateByUrl(`/collections/${payment.contactId}?pay=${payment.id}`)
    }
}
